<template>
    <div style="height: 60px">
        <van-tabbar v-model="active" route>
            <van-tabbar-item name="home" to="/home" v-if="openWidgets.includes('home')">
                <template #icon>
                    <van-icon class-prefix="icon" name="compass" size="23" />
                </template>
                首页
            </van-tabbar-item>

            <van-tabbar-item name="bible" icon="notes-o" to="/bible" v-if="openWidgets.includes('bible')">
                <template #icon>
                    <van-icon class-prefix="icon" name="bible" size="21" />
                </template>
                圣经
            </van-tabbar-item>

            <van-tabbar-item name="poem" icon="service-o" to="/poem" v-if="openWidgets.includes('poem')">
                <template #icon>
                    <van-icon class-prefix="icon" name="customerservice" size="23" />
                </template>
                诗颂
            </van-tabbar-item>

            <van-tabbar-item name="live" icon="tv-o" to="/live" v-if="openWidgets.includes('live')">
                <template #icon>
                    <van-icon class-prefix="icon" name="video" size="23" />
                </template>
                聚会
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    name: 'Tabbar',
    data() {
        return {
            active: 'video',
        }
    },
    computed: {
        openWidgets() {
            // console.log(process.env.VUE_APP_OPEN_WIDGETS.split(','))
            return process.env.VUE_APP_OPEN_WIDGETS.split(',')
        },
    },
}
</script>

<style scoped></style>
